<div class='home' style="margin: 10px 10px 10px 10px;">
  <mat-tab-group>
    <mat-tab label="Systems">
      <div style="text-align: right; margin-bottom: 10px;">
        <p-multiSelect [options]="widgetOptions"
                       [(ngModel)]="visibleWidgets"
                       (onChange)="onPanelHide()">
          <ng-template let-value pTemplate="selectedItems">
            {{ visibleWidgets.length }} items selected
          </ng-template>
        </p-multiSelect>
      </div>
      <div style="display: flex; flex-direction: row; flex-wrap: wrap"
           *ngIf='isProjectsEnabled &&selectedProject != null && implementationStatusCount'>
        <!--Control Implementation Status-->
        <div class="col-md-4" *ngIf="widgetSettings['Control Implementation Status'].visible">
          <div class="box box-info">
            <div class="box-header with-border">
              <h3 class="box-title">Control Implementation Status</h3>
              <div class="box-title" style="margin-left: 15px; display: flex; flex-direction: row;">
                <mat-form-field class="project-list">
                  <mat-select [(ngModel)]="selectedProject"
                              name="projects"
                              (ngModelChange)="onProjectChange($event)">

                    <mat-option *ngFor="let project of projects" [value]="project">
                      {{ project.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <a
                  href="{{this.config.api + '/api/projects/project/' + selectedProject.projectId + '/implementationstatus' + '?token=' + userToken}}"><img
                  src="../../../assets/icons/square-o/pdf.svg"
                  style="margin-left: 10px;height: 28px;opacity: 0.17" /></a>
              </div>

              <div class="box-tools pull-right">
                <!--div class="btn-group">
                <button type="button" class="btn btn-box-tool dropdown-toggle" data-toggle="dropdown">
                    <i class="fa fa-wrench"></i>
                </button>
                </div-->
                <button type="button" class="btn btn-box-tool" data-widget="remove"
                        (click)="hideWidget('Control Implementation Status')">
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>

            <div class="box-body"
                 style="min-height:280px;">
              <div class="chart-responsive" *ngIf="implementationStatusData && implementationStatusBarOptions">
                <p-chart type="bar"
                         [data]="implementationStatusData"
                         [options]="implementationStatusBarOptions"
                         height="235px" width="100%"
                         (onDataSelect)="selectImplementationStatusBar($event)">
                </p-chart>
              </div>
            </div>
          </div>
        </div>
        <!--Gaps-->
        <div class="col-md-4" *ngIf="widgetSettings['Gaps'].visible">
          <div class="box box-info">
            <div class="box-header with-border">
              <h3 class="box-title">Gaps</h3>
              <div class="box-title" style="margin-left: 15px;">
                <mat-form-field class="project-list">
                  <mat-select [(ngModel)]="selectedProject"
                              name="projects"
                              (ngModelChange)="onProjectChange($event)">

                    <mat-option *ngFor="let project of projects" [value]="project">
                      {{ project.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="box-tools pull-right">
                <button type="button" class="btn btn-box-tool" data-widget="remove" (click)="hideWidget('Gaps')">
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>

            <div class="box-body"
                 style="min-height:280px;">
              <div class="row">
                <div class="col-md-12">
                  <div class="chart-responsive" *ngIf="gapsData && gapsOptions">
                    <p-chart type="bar"
                             [data]="gapsData"
                             [options]="gapsOptions"
                             height="235px" width="100%">
                    </p-chart>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--Project Completion Status-->
        <div class="col-md-4" *ngIf="widgetSettings['Recurring Tasks'].visible">
          <div class="box box-info">
            <div class="box-header with-border">
              <h3 class="box-title">Recurring Control Tasks</h3>
              <div class="box-title" style="margin-left: 15px; display: inline-block;">
                <mat-form-field class="project-list">
                  <mat-select [(ngModel)]="selectedProject"
                              name="projects"
                              (ngModelChange)="onProjectChange($event)">

                    <mat-option *ngFor="let project of projects" [value]="project">
                      {{ project.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="box-title" style="margin-left: 15px; display: inline-block;">
                <mat-form-field class="project-list">
                  <mat-select [(ngModel)]="selectedFrequency"
                              name="projects"
                              (ngModelChange)="onFrequencyChange($event)">

                    <mat-option *ngFor="let period of periods" [value]="period.value">
                      {{ period.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="box-tools pull-right">
                <!--div class="btn-group">
                <button type="button" class="btn btn-box-tool dropdown-toggle" data-toggle="dropdown">
                    <i class="fa fa-wrench"></i>
                </button>
                </div-->
                <button type="button" class="btn btn-box-tool" data-widget="remove"
                        (click)="hideWidget('Recurring Tasks')">
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>

            <div class="box-body"
                 style="min-height:280px;">
              <div class="row">
                <div class="col-md-4">
                  <div>
                    Completed: {{ completed + notCompleted > 0 ? getStatusPercentage(completed, completed + notCompleted) : 100 }}
                    % ({{ completed }})
                  </div>
                  <div>Not
                    Completed: {{ completed + notCompleted > 0 ? getStatusPercentage(notCompleted, completed + notCompleted) : 0 }}
                    % ({{ notCompleted }})
                  </div>
                </div>

                <div class="col-md-7">
                  <div class="chart-responsive">
                    <p-chart type="pie"
                             [data]="projectStatusPercentageData"
                             [options]="projectStatusPercenatgeBarOptions"
                             height="235px"
                             (onDataSelect)="selectBar($event)">
                    </p-chart>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--Gaps - All Projects-->
        <div class="col-md-4" *ngIf="widgetSettings['Gaps - All Projects'].visible">
          <div class="box box-info">
            <div class="box-header with-border">
              <h3 class="box-title">Gaps - All Projects</h3>
              <div class="box-title" style="margin-left: 15px;">
              </div>

              <div class="box-tools pull-right">
                <button type="button" class="btn btn-box-tool" data-widget="remove"
                        (click)="hideWidget('Gaps - All Projects')">
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>

            <div class="box-body"
                 style="min-height:280px;">
              <div class="row">
                <div class="col-md-12">
                  <div class="chart-responsive" *ngIf="allGapsData && allGapsOptions">
                    <p-chart type="bar"
                             [data]="allGapsData"
                             [options]="allGapsOptions"
                             height="235px" width="100%">
                    </p-chart>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--Project Level Status-->
        <div class="col-md-4" *ngIf="selectedProject.levels && widgetSettings['Project Level Status'].visible">
          <div class="box box-info">
            <div class="box-header with-border">
              <h3 class="box-title">Status by Level</h3>
              <div class="box-title" style="margin-left: 15px;">
                <mat-form-field class="project-list">
                  <mat-select [(ngModel)]="selectedProject"
                              name="projects"
                              (ngModelChange)="onProjectChange($event)">

                    <mat-option *ngFor="let project of projects" [value]="project">
                      {{ project.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="box-tools pull-right">
                <!--div class="btn-group">
                <button type="button" class="btn btn-box-tool dropdown-toggle" data-toggle="dropdown">
                    <i class="fa fa-wrench"></i>
                </button>
                </div-->
                <button type="button" class="btn btn-box-tool" data-widget="remove"
                        (click)="hideWidget('Project Level Status')">
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>

            <div class="box-body"
                 style="min-height:280px;">
              <div class="row">
                <div class="col-md-4">
                  <div>Completed:</div>
                  <div *ngFor="let levelData of selectedProject.levels">{{ levelData.name }}
                    : {{ levelData.itemsCompleted / levelData.itemsCount * 100  | number : '1.0-0' }}%
                  </div>
                </div>

                <div class="col-md-7">
                  <div class="chart-responsive">
                    <p-chart type="bar"
                             [data]="projectStatusLevelPercentageData"
                             [options]="projectStatusLevelPercenatgeBarOptions"
                             height="235px"
                    >
                    </p-chart>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--Projects Totals-->
        <div class="col-md-4" *ngIf="totalData && widgetSettings['Projects Totals'].visible">
          <div class="box box-info">
            <div class="box-header with-border">
              <h3 class="box-title">Projects Totals</h3>
              <div class="box-tools pull-right">
                <!--div class="btn-group">
                <button type="button" class="btn btn-box-tool dropdown-toggle" data-toggle="dropdown">
                    <i class="fa fa-wrench"></i>
                </button>
                </div-->
                <button type="button" class="btn btn-box-tool" data-widget="remove"
                        (click)="hideWidget('Projects Totals')">
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>

            <div class="box-body"
                 style="min-height:280px;">
              <div class="chart-responsive">
                <p-chart type="bar"
                         [data]="totalData"
                         [options]="totalOptions"
                         height="235px">
                </p-chart>
                <div style="text-align: center;line-height: 15px; ">
              <span
                style="width: 40px; height: 15px;display: inline-block;background-color: #6200db; margin: 0 3px;"></span>Completed
                  <span
                    style="width: 40px; height: 15px; display: inline-block; background-color: #18044a; margin: 0 3px;"></span>Remaining
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--Controls to Complete This Month - All Projects-->
        <div class="col-md-4"
             *ngIf="isProjectsEnabled && selectedProject != null && selectedProject.levels && widgetSettings['Controls to Complete This Month - All Projects'].visible">
          <div class="box box-info">
            <div class="box-header with-border">
              <h3 class="box-title">This Month's Control Tasks</h3>


              <div class="box-tools pull-right">
                <button type="button" class="btn btn-box-tool" data-widget="remove"
                        (click)="hideWidget('Controls to Complete This Month - All Projects')">
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>

            <div class="box-body"
                 style="height:350px;">
              <p-table [value]="projectControlItemsToComplete"
                       [rows]="6"
                       [paginator]="true"
                       [pageLinks]="5"
                       rowGroupMode="subheader"
                       data-groupField="projectName"
                       expandableRowGroups="true"
                       [reorderableColumns]="true"
                       exportFilename="ControlsToCompleteThisMonth"
                       #projectControlItemsToCompleteTable
                       dataKey="projectName"
                       (onSort)="updateProjectControlItemsToCompleteGrouping()"
                       (onFilter)="updateProjectControlItemsToCompleteGrouping()">
                <ng-template pTemplate="caption">
                  <div class="ui-helper-clearfix flex flex-row justify-content-end">
                    <button type="button"
                            pButton
                            class="risksponge-button"
                            icon="pi pi-file-excel"
                            iconPos="left"
                            (click)="projectControlItemsToCompleteTable.exportCSV()"
                    >
                    </button>
                  </div>
                </ng-template>
                <ng-template pTemplate="header">
                  <tr [ngStyle]="{'white-space': 'nowrap', 'font-weight': 'bold'}">
                    <th *ngFor="let col of controlsToCompleteThisMonthCols" [pSortableColumn]="col.field">
                      {{ col.header }}
                      <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                  ariaLabelDesc="Activate to sort in descending order"
                                  ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    </th>
                    <th></th>
                  </tr>
                  <tr>
                    <th *ngFor="let col of controlsToCompleteThisMonthCols" [ngSwitch]="col.field">
                      <input *ngSwitchDefault pInputText type="text" placeholder="⌕"
                             (input)="projectControlItemsToCompleteTable.filter($event.target['value'], col.field, 'contains')">
                      <span *ngSwitchCase="'dueDate'"></span>
                    </th>
                    <th></th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded"
                             let-columns="columns">
                  <tr class="ui-widget-header"
                      *ngIf="projectControlItemsToCompleteRowGroupMetadata && projectControlItemsToCompleteRowGroupMetadata[item.projectName].index === rowIndex">
                    <td colspan="5">
                      <a href="#" [pRowToggler]="item">
                        <i
                          [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                        <span>{{ item.projectName }}</span>
                      </a>
                    </td>
                  </tr>
                </ng-template>

                <ng-template pTemplate="expandedrow" let-rowIndex="rowIndex" let-item>
                  <tr>
                    <td>{{ item.controlItem.complianceAreaControlId }}</td>
                    <td>{{ item.controlItem.category }}</td>
                    <td>{{ getFullName(item.assignedClient) }}</td>
                    <td>{{ item.dueDate | date:'shortDate' }}</td>
                    <td>
                      <button type="button"
                              pButton
                              class="risksponge-button"
                              (click)="editControlItemToComplete(item.projectControlItemId)"
                              icon="pi pi-pencil">
                      </button>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
        <!--Policies Requiring Approval-->
        <div class="col-md-4"
             *ngIf="isProjectsEnabled && selectedProject != null && widgetSettings['Policies Requiring Approval'].visible">
          <div class="box box-info">
            <div class="box-header with-border">
              <h3 class="box-title">Policies Requiring Approval</h3>


              <div class="box-tools pull-right">
                <button type="button" class="btn btn-box-tool" data-widget="remove"
                        (click)="hideWidget('Policies Requiring Approval')">
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>

            <div class="box-body"
                 style="height:350px;">
              <p-table [value]="policies"
                       dataKey="id"
                       [rows]="6"
                       [paginator]="true"
                       [pageLinks]="5"
                       [tableStyle]="{ 'table-layout': 'fixed' }">
                <ng-template pTemplate="header">
                  <tr>
                    <th class="no-wrap-ellipsis">Name</th>
                    <th class="no-wrap-ellipsis">Owner</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item let-expanded="expanded" let-i="rowIndex">
                  <tr>

                    <td [pRowToggler]="item" class="no-wrap-ellipsis">{{ item.name }}</td>
                    <td class="no-wrap-ellipsis">{{ getFullNameById(item.ownerId) }}</td>
                  </tr>
                </ng-template>
              </p-table>

            </div>
          </div>
        </div>
        <!--All Open Controls-->
        <div class="col-md-4"
             *ngIf="isProjectsEnabled && selectedProject != null && isProjectsEnabled && widgetSettings['All Open Controls'].visible">
          <div class="box box-info">
            <div class="box-header with-border">
              <h3 class="box-title">All Open Controls</h3>
              <div class="box-title" style="margin-left: 15px;">
                <mat-form-field class="project-list">
                  <mat-select [(ngModel)]="selectedProject"
                              name="projects"
                              (ngModelChange)="onProjectChange($event)">

                    <mat-option *ngFor="let project of projects" [value]="project">
                      {{ project.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="box-tools pull-right">
                <button type="button" class="btn btn-box-tool" data-widget="remove"
                        (click)="hideWidget('All Open Controls')">
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>

            <div class="box-body"
                 style="min-height:280px;">
              <p-table [value]="selectedProjectCategoriesStatistics"
                       [rows]="4"
                       [paginator]="true"
                       [pageLinks]="5"
                       [reorderableColumns]="true"
                       #monthsControls
                       dataKey="projectName"
                       (onSort)="updateProjectControlItemsToCompleteGrouping()"
                       (onFilter)="updateProjectControlItemsToCompleteGrouping()">
                <ng-template pTemplate="header">
                  <tr [ngStyle]="{'white-space': 'nowrap', 'font-weight': 'bold'}">
                    <th *ngFor="let col of selectedProjectCategoriesStatisticsCols" [pSortableColumn]="col.field">
                      {{ col.header }}
                      <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                  ariaLabelDesc="Activate to sort in descending order"
                                  ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    </th>
                    <th></th>
                  </tr>
                  <tr>
                    <th *ngFor="let col of selectedProjectCategoriesStatisticsCols" [ngSwitch]="col.field">
                      <input *ngSwitchDefault pInputText type="text" placeholder="⌕"
                             (input)="projectControlItemsToCompleteTable.filter($event.target['value'], col.field, 'contains')">
                      <span *ngSwitchCase="'dueDate'"></span>
                    </th>
                    <th></th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
                  <tr>
                    <td>{{ item.name }}</td>
                    <td><span [style.color]="getCategoryStatusColor(item.status)">{{ item.status }}</span></td>
                    <td>
                      <button type="button"
                              pButton
                              class="risksponge-button"
                              (click)="openCategory(item.name)"
                              icon="pi pi-folder-open">
                      </button>
                    </td>
                  </tr>
                </ng-template>

              </p-table>
            </div>
          </div>
        </div>
        <!--Controls Awaiting Review-->
        <div class="col-md-4"
             *ngIf="isProjectsEnabled && selectedProject != null && widgetSettings['Controls Awaiting Review'].visible">
          <div class="box box-info">
            <div class="box-header with-border">
              <h3 class="box-title">Controls Awaiting Review</h3>
              <div class="box-title" style="margin-left: 15px;">
                <mat-form-field class="project-list">
                  <mat-select [(ngModel)]="selectedProject"
                              name="projects"
                              (ngModelChange)="onProjectChange($event)">

                    <mat-option *ngFor="let project of projects" [value]="project">
                      {{ project.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="box-tools pull-right">
                <!--div class="btn-group">
                    <button type="button" class="btn btn-box-tool dropdown-toggle" data-toggle="dropdown">
                    <i class="fa fa-wrench"></i>
                    </button>
                </div-->
                <button type="button" class="btn btn-box-tool" data-widget="remove"
                        (click)="hideWidget('Controls Awaiting Review')">
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>

            <div class="box-body"
                 style="min-height:280px;">
              <p-table [value]="selectedProjectControlItemsAwaitingReview"
                       [rows]="4"
                       [paginator]="true"
                       [pageLinks]="5"
                       [reorderableColumns]="true"
                       #monthsControls>

                <ng-template pTemplate="header">
                  <tr [ngStyle]="{'white-space': 'nowrap', 'font-weight': 'bold'}">
                    <th *ngFor="let col of controlsToCompleteThisMonthCols" [pSortableColumn]="col.field">
                      {{ col.header }}
                      <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                  ariaLabelDesc="Activate to sort in descending order"
                                  ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    </th>
                    <th></th>
                  </tr>
                  <tr>
                    <th *ngFor="let col of controlsToCompleteThisMonthCols" [ngSwitch]="col.field">
                      <input *ngSwitchDefault pInputText type="text" placeholder="⌕"
                             (input)="monthsControls.filter($event.target['value'], col.field, 'contains')">
                      <span *ngSwitchCase="'dueDate'"></span>
                    </th>
                    <th></th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
                  <tr>
                    <td>{{ item.controlItem.complianceAreaControlId }}</td>
                    <td>{{ item.controlItem.category }}</td>
                    <td>{{ getFullName(item.assignedClient) }}</td>
                    <td>{{ item.dueDate | date:'shortDate' }}</td>
                    <td>
                      <button type="button"
                              pButton
                              class="risksponge-button"
                              (click)="editRecurringControlItem(item.projectControlItemId)"
                              icon="pi pi-pencil">
                      </button>
                    </td>
                  </tr>
                </ng-template>

              </p-table>
            </div>
          </div>
        </div>
        <!--Recently Reviewed Controls-->
        <div class="col-md-4"
             *ngIf="isProjectsEnabled && selectedProject != null && widgetSettings['Recently Reviewed Controls'].visible">
          <div class="box box-info">
            <div class="box-header with-border">
              <h3 class="box-title">Recently Reviewed Controls</h3>
              <h3 class="box-title"
                  *ngIf='projectControlItemsToReview != null'> - {{ projectControlItemsToReview.length }}</h3>

              <div class="box-tools pull-right">
                <!--div class="btn-group">
                    <button type="button" class="btn btn-box-tool dropdown-toggle" data-toggle="dropdown">
                    <i class="fa fa-wrench"></i>
                    </button>
                </div-->
                <button type="button" class="btn btn-box-tool" data-widget="remove"
                        (click)="hideWidget('Recently Reviewed Controls')">
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>

            <div class="box-body"
                 style="height:350px;">
              <p-table [value]="projectControlItemsToReview"
                       [rows]="3"
                       [paginator]="true"
                       [pageLinks]="5"
                       [reorderableColumns]="true"
                       rowGroupMode="subheader"
                       data-groupField="projectName"
                       expandableRowGroups="true"
                       exportFilename="ControlsToCerttifyThisMonth"
                       #projectControlItemsToReviewTable
                       dataKey="projectName"
                       (onSort)="updateProjectControlItemsToReviewGrouping()"
                       (onFilter)="updateProjectControlItemsToReviewGrouping()">

                <ng-template pTemplate="caption">
                  <div class="ui-helper-clearfix flex flex-row justify-content-end">
                    <button type="button"
                            pButton
                            class="risksponge-button"
                            icon="pi pi-file-excel"
                            iconPos="left"
                            (click)="projectControlItemsToReviewTable.exportCSV()"
                    >
                    </button>
                  </div>
                </ng-template>
                <ng-template pTemplate="header">
                  <tr [ngStyle]="{'white-space': 'nowrap', 'font-weight': 'bold'}">
                    <th *ngFor="let col of controlsToCompleteThisMonthCols" [pSortableColumn]="col.field">
                      {{ col.header }}
                      <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                  ariaLabelDesc="Activate to sort in descending order"
                                  ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    </th>
                    <th></th>
                  </tr>
                  <tr>
                    <th *ngFor="let col of controlsToCompleteThisMonthCols" [ngSwitch]="col.field">
                      <input *ngSwitchDefault pInputText type="text" placeholder="⌕"
                             (input)="projectControlItemsToReviewTable.filter($event.target['value'], col.field, 'contains')">
                      <span *ngSwitchCase="'dueDate'"></span>
                    </th>
                    <th></th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded"
                             let-columns="columns">
                  <tr class="ui-widget-header"
                      *ngIf="projectControlItemsToReviewRowGroupMetadata && projectControlItemsToReviewRowGroupMetadata[item.projectName]?.index === rowIndex">
                    <td colspan="5">
                      <a href="#" [pRowToggler]="item">
                        <i
                          [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                        <span>{{ item.projectName }}</span>
                      </a>
                    </td>
                  </tr>
                </ng-template>

                <ng-template pTemplate="expandedrow" let-rowIndex="rowIndex" let-item>
                  <tr>
                    <td>{{ item.controlItem.complianceAreaControlId }}</td>
                    <td>{{ item.controlItem.category }}</td>
                    <td>{{ getFullName(item.assignedClient) }}</td>
                    <td>{{ item.dueDate | date:'shortDate' }}</td>
                    <td>
                      <button type="button"
                              pButton
                              class="risksponge-button"
                              (click)="editControlItemToReview(item.projectControlItemId)"
                              icon="pi pi-pencil">
                      </button>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
        <!--Course Status-->
        <div class="col-md-4" *ngIf="trainingData && widgetSettings['Course Status'].visible">
          <div class="box box-info">
            <div class="box-header with-border">
              <h3 class="box-title">Course Status</h3>
              <div class="box-tools pull-right">
                <!--div class="btn-group">
                <button type="button" class="btn btn-box-tool dropdown-toggle" data-toggle="dropdown">
                    <i class="fa fa-wrench"></i>
                </button>
                </div-->
                <button type="button" class="btn btn-box-tool" data-widget="remove"
                        (click)="hideWidget('Course Status')">
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>

            <div class="box-body"
                 style="min-height:280px;">
              <div class="chart-responsive">
                <p-chart type="bar"
                         [data]="trainingData"
                         [options]="trainingOptions"
                         height="235px">
                </p-chart>
              </div>
            </div>
          </div>
        </div>
        <!--Survey Status-->
        <div class="col-md-4" *ngIf="surveyData && widgetSettings['Survey Status'].visible">
          <div class="box box-info">
            <div class="box-header with-border">
              <h3 class="box-title">Survey Status</h3>
              <div class="box-tools pull-right">
                <!--div class="btn-group">
                <button type="button" class="btn btn-box-tool dropdown-toggle" data-toggle="dropdown">
                    <i class="fa fa-wrench"></i>
                </button>
                </div-->
                <button type="button" class="btn btn-box-tool" data-widget="remove"
                        (click)="hideWidget('Survey Status')">
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>

            <div class="box-body"
                 style="min-height:280px;">
              <div class="chart-responsive">
                <p-chart type="bar"
                         [data]="surveyData"
                         [options]="surveyOptions"
                         height="235px">
                </p-chart>
              </div>
            </div>
          </div>
        </div>
        <!--Items Requiring Evidence Attachment-->
        <div class="col-md-4"
             *ngIf="isProjectsEnabled && selectedProject != null && widgetSettings['Items Requiring Evidence Attachment'].visible">
          <div class="box box-info">
            <div class="box-header with-border">
              <h3 class="box-title">Items Requiring Evidence Attachment</h3>
              <div class="box-title" style="margin-left: 15px;">
                <mat-form-field class="project-list">
                  <mat-select [(ngModel)]="selectedProject"
                              name="projects"
                              (ngModelChange)="onProjectChange($event)">

                    <mat-option *ngFor="let project of projects" [value]="project">
                      {{ project.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="box-tools pull-right">
                <!--div class="btn-group">
                    <button type="button" class="btn btn-box-tool dropdown-toggle" data-toggle="dropdown">
                    <i class="fa fa-wrench"></i>
                    </button>
                </div-->
                <button type="button" class="btn btn-box-tool" data-widget="remove"
                        (click)="hideWidget('Items Requiring Evidence Attachment')">
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>

            <div class="box-body"
                 style="min-height:280px;">
              <p-table [value]="selectedProjectControlItemsWithoutEvidence"
                       [rows]="4"
                       [paginator]="true"
                       [pageLinks]="5"
                       [reorderableColumns]="true"
                       #monthsControls>

                <ng-template pTemplate="header">
                  <tr [ngStyle]="{'white-space': 'nowrap', 'font-weight': 'bold'}">
                    <th *ngFor="let col of controlsExpectingEvidenceCols" [pSortableColumn]="col.field">
                      {{ col.header }}
                      <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                  ariaLabelDesc="Activate to sort in descending order"
                                  ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    </th>
                    <th></th>
                  </tr>
                  <tr>
                    <th *ngFor="let col of controlsExpectingEvidenceCols" [ngSwitch]="col.field">
                      <input *ngSwitchDefault pInputText type="text" placeholder="⌕"
                             (input)="monthsControls.filter($event.target['value'], col.field, 'contains')">
                      <span *ngSwitchCase="'dueDate'"></span>
                    </th>
                    <th></th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
                  <tr>
                    <td>{{ item.controlItem.complianceAreaControlId }}</td>
                    <td>{{ item.controlItem.category }}</td>
                    <td>{{ getFullName(item.assignedClient) }}</td>
                    <td>{{ item.evidenceDueDate | date:'shortDate' }}</td>
                    <td>
                      <button type="button"
                              pButton
                              class="risksponge-button"
                              (click)="editRecurringControlItem(item.projectControlItemId)"
                              icon="pi pi-pencil">
                      </button>
                    </td>
                  </tr>
                </ng-template>

              </p-table>
            </div>
          </div>
        </div>
        <!--Compliance Bulletins-->
        <div class="col-md-4" *ngIf="bulletins != null && widgetSettings['Compliance Bulletins'].visible">
          <div class="box box-info">
            <div class="box-header with-border">
              <h3 class="box-title">Compliance Bulletins</h3>

              <div class="box-tools pull-right">
                <button type="button" class="btn btn-box-tool" data-widget="remove"
                        (click)="hideWidget('Compliance Bulletins')">
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>

            <div class="box-body"
                 style="height:350px;">
              <p-table [value]="bulletins"
                       [rows]="5"
                       [paginator]="true"
                       [pageLinks]="5"
                       [reorderableColumns]="true"
                       rowGroupMode="subheader"
                       exportFilename="Bulletins"
                       #bulletinsTable
                       sortField="date"
              >

                <ng-template pTemplate="header">
                  <tr [ngStyle]="{'white-space': 'nowrap', 'font-weight': 'bold'}">
                    <th *ngFor="let col of bulletinsCols" [pSortableColumn]="col.field">
                      {{ col.header }}
                      <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                  ariaLabelDesc="Activate to sort in descending order"
                                  ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    </th>
                  </tr>
                  <tr>
                    <th *ngFor="let col of bulletinsCols" [ngSwitch]="col.field">
                      <input *ngSwitchDefault pInputText type="text" placeholder="⌕"
                             (input)="monthsControls.filter($event.target['value'], col.field, 'contains')">
                      <span *ngSwitchCase="'date'"></span>
                    </th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
                  <tr (click)="bulletinRowClick(item)">
                    <td>{{ item.areaName }}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.type }}</td>
                    <td>{{ item.date | date:'shortDate' }}</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="isProjectsEnabled && actionPlans">
        <div class="box box-info">
          <div class="box-header with-border">
            <h3 class="box-title">Gaps & POAMs</h3>
          </div>
          <mat-button-toggle-group #group="matButtonToggleGroup" style="width: 270px;" [value]="2"
                                   (change)="filterActionPlan(group.value)">
            <mat-button-toggle [value]="0" style="width: 33%;">
              POAM
            </mat-button-toggle>
            <mat-button-toggle [value]="1" style="width: 33%;">
              Internal
            </mat-button-toggle>
            <mat-button-toggle [value]="2" style="width: 33%;">
              All
            </mat-button-toggle>
          </mat-button-toggle-group>

          <p-table [value]="filteredActionPlans"
                   [rows]="10"
                   [reorderableColumns]="true"
                   exportFilename="ActionPlans"
                   #actionPlanTable
                   [columns]="actionPlanCols"
                   dataKey="projectName"
                   [expandedRowKeys]="expandedActionPlanProjects"
          >
            <ng-template pTemplate="caption">
              <div class="ui-helper-clearfix flex flex-row justify-content-end">
                <button type="button"
                        pButton
                        class="risksponge-button"
                        icon="pi pi-file-excel"
                        iconPos="left"
                        (click)="actionPlanTable.exportCSV()"
                >
                </button>
              </div>
            </ng-template>
            <ng-template pTemplate="header">
              <tr [ngStyle]="{'white-space': 'nowrap', 'font-weight': 'bold'}">
                <th *ngFor="let col of actionPlanCols" [pSortableColumn]="col.field"
                    [ngStyle]="{'width': col.width || 'auto'}">
                  {{ col.header }}
                  <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                              ariaLabelDesc="Activate to sort in descending order"
                              ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
              </tr>
              <tr>
                <th *ngFor="let col of controlsToCompleteThisMonthCols" [ngSwitch]="col.field">
                  <input *ngSwitchDefault pInputText type="text" placeholder="⌕"
                         (input)="actionPlanTable.filter($event.target['value'], col.field, 'contains')">
                  <span *ngSwitchCase="'identificationDate'"></span>
                </th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded"
                         let-columns="columns">
              <tr class="ui-widget-header"
                  *ngIf="actionPlanRowGroupMetadata && actionPlanRowGroupMetadata[item.projectName].index === rowIndex">
                <td colspan="5">
                  <a href="#" [pRowToggler]="item">
                    <i
                      [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                    <span>{{ item.projectName }}</span>
                  </a>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="expandedrow" let-rowIndex="rowIndex" let-item>
              <tr>
                <td><a [routerLink]="['/projects/project', item.projectId, item.projectControlItemId]"
                       [queryParams]="{projectControlItem: item.projectControlItemId}">{{ item.controlItemId }}</a></td>
                <td>{{ item.weaknessDescription }}</td>
                <td>{{ item.responsibleParty }}</td>
                <td>{{ item.identificationDateValue }}</td>
                <td>{{ item.currentStatusValue }}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
      <div class="box box-info">
        <div class="box-header with-border">
          <h3 class="box-title">Projects</h3>
        </div>
        <p-table *ngIf="isProjectsEnabled && selectedProject != null && projects" [value]="projects"
                 [rows]="10"
                 [paginator]="true"
                 [pageLinks]="5"
                 [reorderableColumns]="true"
                 [rowsPerPageOptions]="[10, 20, 50, 100]"
                 [style]="{'margin-top':'10px'}"
                 #dt
                 dataKey="projectId">

          <ng-template pTemplate="header">
            <tr [ngStyle]="{'white-space': 'nowrap', 'font-weight': 'bold'}">
              <th [pSortableColumn]="'name'" style="text-align: center;">
                Name
                <p-sortIcon [field]="'name'" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
              </th>
              <th style="text-align: center;">Implemented</th>
              <th style="text-align: center;">Open</th>
              <th style="text-align: center;">Total Controls</th>
              <th style="text-align: center;">Advisor</th>
              <th style="text-align: center;">Manager</th>
              <th></th>
            </tr>
            <tr>
              <th>
                <input pInputText type="text" placeholder="⌕"
                       (input)="dt.filter($event.target['value'], 'name', 'contains')">
              </th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
            <tr>
              <td>{{ item.name }}</td>
              <td style="text-align: center;">{{ item.itemsImplemented }}</td>
              <td style="text-align: center;">{{ item.itemsRemaining }}</td>
              <td style="text-align: center;">{{ item.itemsCount }}</td>
              <td>{{ getProjectConsultant(item) }}</td>
              <td>{{ getProjectClient(item) }}</td>
              <td style="text-align: center;">
                <button type="button"
                        pButton
                        class="risksponge-button"
                        (click)="openProject(item.projectId)"
                        icon="pi pi-folder-open">
                </button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <div class="box box-info">
        <div class="box-header with-border">
          <h3 class="box-title">Summary Statistics</h3>
        </div>
        <p-table *ngIf="isProjectsEnabled && selectedProject != null && projects" [value]="projects"
                 [style]="{'margin-top':'10px'}"
                 #dt
                 dataKey="projectId">

          <ng-template pTemplate="header">
            <tr [ngStyle]="{'white-space': 'nowrap', 'font-weight': 'bold'}">
              <th [pSortableColumn]="'name'" style="text-align: center;">
                Name
                <p-sortIcon [field]="'name'" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
              </th>
              <th style="text-align: center;">% Implemented</th>
              <th style="text-align: center;"># Gaps</th>
              <th style="text-align: center;">Open Tasks</th>
              <th style="text-align: center;"># RizkList</th>
              <th></th>
            </tr>
            <tr>
              <th>
                <input pInputText type="text" placeholder="⌕"
                       (input)="dt.filter($event.target['value'], 'name', 'contains')">
              </th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
            <tr>
              <td>{{ item.name }}</td>
              <td
                style="text-align: center;">{{ (item.itemsImplemented * 100 / (item.itemsCount == 0 ? 1 : item.itemsCount)) | number : '0.00' }}
                %
              </td>
              <td style="text-align: center;">{{ item.poamCount }}</td>
              <td style="text-align: center;">{{ item.hasThisMonthOpenTasks ? 'Yes' : 'No' }}</td>
              <td style="text-align: center;">{{ item.highRiskCount }}</td>
              <td style="text-align: center;">
                <button type="button"
                        pButton
                        class="risksponge-button"
                        (click)="openProject(item.projectId)"
                        icon="pi pi-folder-open">
                </button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </mat-tab>
    <mat-tab label="Fleets">
      <fleetsDashboard></fleetsDashboard>
    </mat-tab>
  </mat-tab-group>
</div>
